import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import {
  routerForBrowser,
  initializeCurrentLocation
} from "redux-little-router";
import thunk from "redux-thunk";
import axios from "axios";
import "./index.css";
import { MuiThemeProvider } from "material-ui/styles";
import Layout from "./containers/Layout";
import registerServiceWorker from "./registerServiceWorker";
import brc from "./store/reducer";
import theme from "./muiTheme";

import TouchRipple from "material-ui/ButtonBase/TouchRipple";
import IFrame from "./components/IFrame";

TouchRipple.prototype.render = () => null;

axios.defaults.baseURL = process.env.REACT_APP_BRC_API_URL;

function App() {
  const url = window.location.href;
  const iFrameUrl = url.toLowerCase().includes("iframe");
  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>{iFrameUrl ? <IFrame /> : <Layout />}</Provider>
    </MuiThemeProvider>
  );
}

const routes = {
  "/": {
    title: "Beach Report Card"
  },
  "/iframe": {
    title: "iFrame"
  }
};
const { reducer, middleware, enhancer } = routerForBrowser({
  routes
});

const logger = (store) => {
  return (next) => {
    return (action) => {
      const result = next(action);
      return result;
    };
  };
};

const store = createStore(
  combineReducers({ router: reducer, brc }),
  {},
  compose(enhancer, applyMiddleware(middleware, logger, thunk))
);

const initialLocation = store.getState().router;
if (initialLocation) {
  store.dispatch(initializeCurrentLocation(initialLocation));
}

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js